import { FC, memo } from 'react';
interface IProps {
  condition: boolean;
  children: React.ReactNode;
}
const ConditionWrapperMemo: FC<IProps> = ({
  children,
  condition
}) => {
  return <>{condition ? children : null}</>;
};
export const ConditionWrapper = memo(ConditionWrapperMemo);